import { Link } from '@tanstack/react-router';

export function StaticFooter() {
  return (
    <footer className="border-t border-slate-200 bg-[#fafafa]">
      <div className="w-full px-6 py-16 sm:py-24 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          {/* Brand */}
          <div className="space-y-8 xl:col-span-1">
            <div className="flex items-center gap-2">
              <img src="/logo.svg" alt="Winbox Zero" className="h-6 w-auto" />
              <span className="font-semibold text-slate-900 tracking-tight">Winbox Zero</span>
            </div>
            <p className="text-sm leading-6 text-slate-500 max-w-xs">
              A smart inbox manager that uses local AI models to categorize, label, and clean up your Gmail autonomously.
            </p>
          </div>
          
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              {/* Product */}
              <div>
                <h3 className="text-sm font-semibold leading-6 text-slate-950">Product</h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li>
                    <Link to="/features" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Features</Link>
                  </li>
                  <li>
                    <Link to="/pricing" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Pricing</Link>
                  </li>
                </ul>
              </div>
              
              {/* Guides */}
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-slate-950">Guides</h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li>
                    <Link to="/inbox-zero" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Inbox Zero Guide</Link>
                  </li>
                  <li>
                    <Link to="/email-cleanup" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Email Cleanup</Link>
                  </li>
                  <li>
                    <Link to="/mass-unsubscribe" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Mass Unsubscribe</Link>
                  </li>
                  <li>
                    <Link to="/email-organization" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Email Organization</Link>
                  </li>
                  <li>
                    <Link to="/email-productivity" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Email Productivity</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="md:grid md:grid-cols-2 md:gap-8">
              {/* Legal */}
              <div>
                <h3 className="text-sm font-semibold leading-6 text-slate-950">Legal</h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li>
                    <Link to="/privacy" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms" className="text-sm leading-6 text-slate-500 hover:text-slate-900 transition-colors">Terms of Service</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom copyright */}
        <div className="mt-16 border-t border-slate-200 pt-8 sm:mt-20 lg:mt-24">
          <p className="text-sm leading-5 text-slate-400">
            &copy; {new Date().getFullYear()} Winbox Zero. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
